var s;!function(s){s.Frames="frames",s.Accessories="accessories",s.ContactLenses="contact-lenses",s.Solutions="solutions",s.Sunglasses="sunglasses",s.ReadyReaders="ready-readers"}(s||(s={}));export{s as ProductType};
//# sourceMappingURL=product-page.js.map
